import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios } from "../config/axiosInstance";

//Send Verify Otp API
export const sendVerifyOtp = async (data) => {
  const responseData = await axios.post("verification-user/send-otp", {
    reqData: encryptData(data),
  });
  return decryptData(responseData?.data || "");
};

//Verify Otp API
export const verifyOtp = async (data) => {
  const responseData = await axios.post("verification-user/verify-otp", {
    reqData: encryptData(data),
  });
  return decryptData(responseData?.data || "");
};

// Resend OTP API
export const resendOtpApi = async (data) => {
  const responseData = await axios.post("verification-user/resend-otp", {
    reqData: encryptData(data),
  });
  return decryptData(responseData?.data || "");
};

// Login User
export const loginUserApi = async (data) => {
  const responseData = await axios.post("user-auth/login-user", {
    reqData: encryptData(data),
  });
  return decryptData(responseData?.data || "");
};

// Reset Password
export const userResetPasswordApi = async (data) => {
  const responseData = await axios.post("user-auth/reset-password", {
    reqData: encryptData(data),
  });
  return decryptData(responseData?.data || "");
};
